import { axios } from '..'

const registerVisualizationGroup = (groupId: string) => {
  return axios.post(`/v1/group/${groupId}/feed/silent-view`, groupId)
}

export default registerVisualizationGroup
